/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { BehaviorSubject, first, Subject } from "rxjs";
import { FormActionsComponent, FormComponent, FormInputComponent, FormPasswordInputComponent, ModalComponent, requiredValidator } from "typedb-cloud-framework";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { SnackbarService } from "../../../../service/snackbar.service";
import { IdentityAuthService } from "../../../../service/authentication/identity-auth.service";
import { DialogResult } from "../../../../service/dialog.service";
import { ApplicationState } from "../../../../service/application-state.service";
import { ReauthenticateComponent, ReauthStage } from "../../../../framework/reauthenticate/reauthenticate.component";

@Component({
    selector: "tp-security-center-reauthenticate-dialog",
    templateUrl: "./security-center-reauthenticate-dialog.component.html",
    styleUrl: "./security-center-reauthenticate-dialog.component.scss",
    standalone: true,
    imports: [
        AsyncPipe, FormsModule, ReactiveFormsModule, ModalComponent,
        MatFormFieldModule, MatInputModule, ReauthenticateComponent
    ],
})
export class SecurityCenterReauthenticateDialogComponent {
    dialogRef: MatDialogRef<SecurityCenterReauthenticateDialogComponent, DialogResult> = inject(MatDialogRef);
    formBuilder = inject(FormBuilder);
    snackbar = inject(SnackbarService);
    auth = inject(IdentityAuthService);
    app = inject(ApplicationState);

    readonly reauthForm = this.formBuilder.nonNullable.group({
        email: ["", [requiredValidator]],
        password: ["", [requiredValidator]],
    });

    isSubmitting$ = new Subject<boolean>();

    dialogTitle$ = new BehaviorSubject<string>("Reauthenticate to access the security center");

    constructor(
    ) {
        this.auth.currentUserStateChanges.pipe(first(user => !!user)).subscribe(user => {
            if (!this.reauthForm.value.email && !!user.email) this.reauthForm.patchValue({ email: user.email });
        });
    }

    reauthStageChanged(stage: ReauthStage) {
        if (stage === "reauthenticate") this.dialogTitle$.next("Reauthenticate to access the security center");
        else if (stage === "verify-identity") this.dialogTitle$.next("Verify your identity");
        else if (stage === "complete") this.close("ok");
    }

    close(result?: DialogResult) {
        this.dialogRef.close(result);
    }
}
